import InlineLink from '../../InlineLink/inline-link'
import { formatPrice } from '../../../utils/helpers'

const concatAddress = (option) => (
  [
    option.address_line_1,
    option.address_line_2,
    option.city,
    option.postcode,
  ].filter((row) => !!row).join(', ')
)

const formatDeliveryOption = (
  option,
  selectedMethod,
  translations,
  locale,
  currency,
) => {
  const details = selectedMethod === 'postal'
    ? option.description
    : concatAddress(option)

  const cta = option.info_url
    ? (
      <InlineLink
        url={option.info_url}
        text={<span className="semi-bold">{translations['deliveryOption.moreInfoLink']}</span>}
        noFollow
        newTab
        external
        iconName="external-link"
      />
    )
    : null

  return {
    id: option.id,
    name: option.name,
    details,
    price: option.price === 0
      ? translations['orderJourney.totals.free']
      : formatPrice({ price: option.price, locale, currency }),
    provider: option.provider,
    cta,
    value: option.id,
  }
}

export default formatDeliveryOption
